export enum ModalType {
  CUSTOM = "CUSTOM",
  NORMAL = "NORMAL",
}
